<div class="cancel-account-wrapper">
  <div class="flex">
    <div class="flex-2">
      <div class="header" translate>
        PLANS.CANCEL_SUBSCRIPTION.TITLE
      </div>
      <div class="text" translate>
        PLANS.CANCEL_SUBSCRIPTION.DESCRIPTION
      </div>
    </div>
    <div class="flex-1 right">
      <button (click)="cancelSubscription()" mat-raised-button color="warn">{{ 'PLANS.CANCEL_SUBSCRIPTION.BUTTON' | translate }}</button>
    </div>
  </div>

</div>
